module.exports = __webpack_public_path__ + "static/media/galeryBaseboards7.034d2910.jpg";